import rank from './rank';
import list from './list';
import highlight from './highlight';
import button from './button';
import carousel from './carousel';
import betteroffer from './better-offer';
const exhibitions = {
  rank,
  list,
  highlight,
  button,
  carousel,
  betteroffer
};
export default exhibitions;